import { useNavigate } from 'react-router';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Menu } from '@mui/icons-material';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';

import TheGuarantorsLogo from '@/assets/images/updated-logo.png';
import { externalConnections, externalLinks, routes } from '@/constants/Constants';
import { Link } from '../../../components/Link';
import { useUrlChecker } from '../../../hooks/useUrlChecker';
import { useGoToExternal } from '../../../utils/linkUtils';
import useMenu from '@/appWrapper/useMenu';

type SiteHeaderProps = {
  isSplitView?: boolean;
};

const SiteHeader = ({ isSplitView = false }: SiteHeaderProps) => {
  const goToExternal = useGoToExternal();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { isSigningUp, isPublic } = useUrlChecker();
  const preRegister = isPublic || window.location.pathname === routes.unitsOwnedEnroll;
  const { openMenu } = useMenu();

  if (isSplitView) return null;
  return (
    <Box
      sx={{
        minHeight: { xs: '100px', sm: '148px' },
        position: 'sticky',
        top: '0px',
        zIndex: 999,
      }}
    >
      <AppBar
        sx={{
          left: 'unset !important',
          right: 'unset !important',
          flex: 1,
          position: 'initial',
          width: 'unset',
        }}
      >
        <Toolbar>
          {isMobile && !preRegister ? (
            <IconButton
              aria-label="open mobile menu drawer"
              edge="start"
              onClick={openMenu}
              sx={{ display: { xs: 'relative', sm: 'none' } }}
            >
              <Menu fontSize="large" />
            </IconButton>
          ) : null}
          {isSigningUp ? (
            <>
              <IconButton
                sx={{ border: '1px solid black', mr: 2 }}
                onClick={() => navigate(-1)}
                id="backButton"
              >
                <ArrowBackIcon sx={{ color: 'black', fontSize: { xs: '12px', md: '22px' } }} />
              </IconButton>
              <Typography
                onClick={() => navigate(-1)}
                sx={{ display: { xs: 'none', sm: 'flex' }, cursor: 'pointer' }}
              >
                Back
              </Typography>
            </>
          ) : null}
          <Box sx={{ flexGrow: 1 }} />
          <img
            onClick={() => {
              goToExternal(externalLinks.homePage, {
                title: 'Go to Main Page',
                path: '/home',
              });
            }}
            style={{ cursor: 'pointer' }}
            height={isMobile ? '20px' : '24px'}
            src={TheGuarantorsLogo}
            alt="TheGuarantors"
          />
          <Box sx={{ flexGrow: 1 }} />
          {isSigningUp ? (
            <Link data-variant="navItem" underline="none" href={externalConnections.signin}>
              Sign In
            </Link>
          ) : null}
          {isMobile && !preRegister ? <Box sx={{ width: '51px' }} /> : null}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default SiteHeader;
